import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPopupEvaluationMailSentPage } from './app-popup-evaluation-mail-sent';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppPopupEvaluationMailSentPage,
  ],
  imports: [
    IonicPageModule.forChild(AppPopupEvaluationMailSentPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppPopupEvaluationMailSentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-popup-evaluation-mail-sent/app-popup-evaluation-mail-sent.module.ts